module.exports = __webpack_public_path__ + "img/barrel-lid.5b9d1140.png";